import { useTranslation } from "react-i18next";

export const AISummaryGenerating = () => {
  const { t } = useTranslation("contacts");

  return <span className="text-sm font-medium text-purple-600 animate-pulse">{t("Generating...")}</span>;
};
